
import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { environment } from '@environments/environment';
import { ApplicationService, ApplicationSettings, IConfigFilter } from '@services/application.service';
import { siteSubscriptions } from '@services/siteSubscriptions';
import { filter, firstValueFrom } from 'rxjs';

export const maintenanceGuard: CanActivateFn = async (route, state): Promise<boolean | UrlTree> => {
	const router = inject(Router);
	const applicationService = inject(ApplicationService);
	const SiteSubscriptions = inject(siteSubscriptions);
	const env = environment;
	/** Environment Variables */


	try {
		// const cfgFilter = <IConfigFilter>{
		// 	application: env.appName,
		// 	environment: env.production ? 'Production' : "Development"
		// }
		// const result = await firstValueFrom(
		// 	applicationService.getSettings$(cfgFilter)
		// );

		// /** Safely retrieve the configuration returned by the API */
		// const data = result?.[0]?.Data;

		// if (!data) {
		// 	return true;
		// }

		// /** Safely parse the application configuration */
		// const appSettings = <ApplicationSettings>JSON.parse(data);

		const appSettings = await firstValueFrom(
			SiteSubscriptions.applicationSettings$.pipe(
				filter(value => value && Object.keys(value).length > 0)
			)
		);

		if (!appSettings?.Config.maintenance?.enabled ||
			appSettings.Config.maintenance.start == null) {
			return true;
		}

		var epoch: number = Date.now();

		/** Maintenance is currently active, so redirect to the maintenance page */
		if (epoch >= appSettings.Config.maintenance.start
			// &&
			// (appSetting.maintenance.end == null ||
			// 	epoch < appSetting.maintenance.end)
		) {

			return router.parseUrl('/maintenance');
		}
	}
	catch (error) {
		/** If configuration cannot be retrieved or parsed, allow navigation */
		console.log(error);
	}

	/** Maintenance is disabled, scheduled for the future, or has ended, so allow navigation */
	return true;
};
